import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { HTTPService } from "src/app/services/http.service";
import { NavService } from "src/app/services//nav.service";
import { MatSidenav } from "@angular/material/sidenav";
import { ThemeService } from "src/app/services/theme.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { GenericEdit } from "src/app/interfaces/generic-edit";
import { DialogService } from "src/app/services/dialog.service";
import { SnackbarService } from "src/app/services/snackbar.service";
import { IntegrationServices } from "src/app/services/integration.services";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { SetupIntegrationViewComponent } from "../setup-integration-view/setup-integration-view.component";
import { NgxSpinnerService } from "ngx-spinner";

import introJs  from "intro.js/intro.js";
import { TutorialServices } from "src/app/services/tutorial.services";
import { RequestTypeServiceComponent } from "../request-type-service/request-type-service.component";
import { PermissionServices } from "src/app/services/permission.services";

@Component({
    selector: "app-type-integration-view",
    templateUrl: "./type-integration-view.component.html",
    styleUrls: ["./type-integration-view.component.scss"],
    standalone: false
})
export class TypeIntegrationViewComponent implements OnInit {
  @ViewChild("sidenav") sidenav: MatSidenav;
  introJS = introJs();
  tipo: String = "";
  isDarkTheme: any;
  data: GenericEdit;
  codeContract: any;
  isWaiting: boolean = true;

  intData = [];
  intDataDone = [];
  intSelectedItem: any;

  @Input() idConf: string;
  @Input() codeCompany: string;
  @Input() nomeConf: string;
  @Input() codeMktp: String;
  canEdit: Boolean = false;
  canInsert: Boolean = false;
  canView: Boolean = false;
  canDelete: Boolean = false;

  constructor(
    public uid: UserAuthenticationServices,
    private themeService: ThemeService,
    private navService: NavService,
    private http: HTTPService,
    private IntegrationServices: IntegrationServices,
    private tutorialServices:TutorialServices,
    private snackBar: SnackbarService,
    private dialogServices: DialogService,
    private ua: UserAuthenticationServices,
    private spinner: NgxSpinnerService,
    private userPermission:PermissionServices,
    public ThemeService:ThemeService
  ) {
    this.spinner.show("integrationsLoading");
    this.loadTypeIntegrations(null);
  }

  ngOnInit(): void {

    this.canEdit = this.userPermission.checkPermissionSession('MKTPCFI','edit');
    this.canInsert = this.userPermission.checkPermissionSession('MKTPCFI','insert');
    this.canView = this.userPermission.checkPermissionSession('MKTPCFI','view');
    this.canDelete = this.userPermission.checkPermissionSession('MKTPCFI','delete');

    this.isDarkTheme = this.themeService.isDarkTheme;

    if (
      this.uid.user.companylist != null &&
      this.uid.user.companylist.length > 0
    ) {
      //VERIFICAR COMO FAZER QUANDO TEM MAIS DE UMA EMPRESA
      this.codeContract = Number(this.uid.user.companylist[0].codecontract);
    }
  }

  showTutorial() {  
    this.tutorialServices.loadByPK("1").then((result) => {
        var resultsTutorial = this.tutorialServices.resultMktpTutorial;

        if(resultsTutorial.length > 0){          
          introJs()
          .setOptions(resultsTutorial[0].tutorial).start();
        }

    });    
    /*introJs()
      .setOptions({
        dontShowAgain: "true",
        dontShowAgainLabel: "Não exibir novamente",
        nextLabel: "Avançar",
        prevLabel: "Voltar",
        doneLabel: "Finalizar",
        steps: [
          {
            element: document.querySelector(".containerMenu"),
            title: "Bem vindo",
            intro: "Essa é a tela de construção das integrações! 👋",
          },
          {
            element: document.querySelector(".listaIntegracoes"),
            intro:
              "Nesse painel você pode selecionar um Tipo de Integração e arrastar para o painel ao lado.",
          },
          {
            element: document.querySelector(".contentContainer"),
            intro:
              "Esse painel vai exibir todas as integrações para essa configuração ",
          },
          {
            element: document.querySelector(".mat-expansion-indicator"),
            intro:
              "Clicando aqui, você consegue visualizar e editar as configurações para as integrações",
          },
        ],
      })
      .start();*/
  }

  showTutorialType() {
    this.tutorialServices.loadByPK("2").then((result) => {
      var resultsTutorial = this.tutorialServices.resultMktpTutorial;

      if(resultsTutorial.length > 0){
        introJs()
        .setOptions(resultsTutorial[0].tutorial).start();
      }

   });    
    /*introJs()
      .setOptions({
        dontShowAgain: "true",
        dontShowAgainLabel: "Não exibir novamente",
        nextLabel: "Avançar",
        prevLabel: "Voltar",
        doneLabel: "Finalizar",
        steps: [
          {
            element: document.querySelector(".iconDone"),
            title: "Tipos de Integração",
            intro:
              "Clicando sobre a integração você abre a janela de configuração novamente!",
          },
        ],
      })
      .start();*/
  }

  ngAfterViewInit() {
    this.navService.appDrawer = this.sidenav;
  }

  toggle(tipo: String) {
    this.tipo = tipo;
    this.sidenav.opened ? this.sidenav.close() : this.sidenav.open();
  }

  openSetupIntegration(sequence, name, typeIntegration) {

    if ( !this.canEdit){
      this.snackBar.showError("Usuário sem permissão de edição.");
      return;
    }

    var integrationRow = {
      idConf: this.idConf,
      sequence: sequence,
      codeCompany: this.codeCompany,
      codeContract: this.codeContract,
      codeMktp: this.codeMktp,
      name: name,
      typeIntegration: typeIntegration
    };
    
    let component:any  = SetupIntegrationViewComponent;

    if ( typeIntegration.nuInt == 1 || typeIntegration.nuInt == 2 || typeIntegration.nuInt == 4
      || typeIntegration.nuInt == 7 || typeIntegration.nuInt == 11 || typeIntegration.nuInt == 12  ){
      component = RequestTypeServiceComponent;
    }
    this.dialogServices.openGenericDialog(
      component,
      integrationRow,
      (popUpData) => {
        if (popUpData != null && popUpData.length > 0) {
          /*let popUpDataArr = Array.prototype.slice.call(popUpData);

          this.copyAcessFromUser(this.userSelectedItem.id, usersDest);*/
        }
      },
      () => {
        this.loadIntegrations();
        //this.showTutorialType();
      },
      "80vh",
      "90vw",
      false,
      null,
      "S",
      '80px'
    );
  }

  close(tipo: String) {
    this.tipo = tipo;
    this.sidenav.close();
  }

  loadTypeIntegrations(filterUser: any) {
    if (filterUser == null || filterUser.length == 0) {
      filterUser = null;
    }

    this.IntegrationServices.getTypeIntegrations(null).then((x) => {
      this.intData = this.IntegrationServices.tipIntArr;
      this.loadIntegrations();
    });
  }

  loadIntegrations() {

    if ( !this.canView){
      this.snackBar.showError("Usuário sem permissão de visualização.");
      this.spinner.hide('integrationsLoading');
      return;
    }

    this.IntegrationServices.loadIntegrations(this.idConf).then((x) => {
      this.intDataDone = [];

      this.IntegrationServices.resultsCfi.forEach((cfi) => {
        var typeIntegration = this.intData.find(
          (x) => x.nuInt == cfi.serviceType
        );

        if (typeIntegration) {
          var integrationCompany = JSON.parse(JSON.stringify(typeIntegration));
          
          integrationCompany.idConf = cfi.idConf;
          integrationCompany.sequence = cfi.sequence;
          integrationCompany.index = cfi.index;
          integrationCompany.nuInt = typeIntegration;
          integrationCompany.nameIntegration = cfi.nameIntegration;
          integrationCompany.active = cfi.active;

          this.intDataDone.push(integrationCompany);
        }
      });
      this.isWaiting = false;
      this.spinner.hide("integrationsLoading");
      this.showTutorial();
    });
  }

  saveIntegration(conf, typeIntegration) {

    if ( !this.canEdit){
      this.snackBar.showError("Usuário sem permissão de edição.");
      return;
    }

    this.IntegrationServices.saveIntegration(conf, typeIntegration.nuInt).then(
      (x) => {
        var integrationCompany = JSON.parse(JSON.stringify(typeIntegration));
        integrationCompany.index = this.intDataDone.length;
        integrationCompany.idConf = this.idConf;
        integrationCompany.sequence = this.IntegrationServices.lastIntegration["SEQUENCE"];
        this.intDataDone.push(integrationCompany);

        this.openSetupIntegration(
          integrationCompany.sequence,
          integrationCompany.name,
          typeIntegration
        );
      }
    );
  }

  removeIntegration(sequence) {

    if ( !this.canDelete){
      this.snackBar.showError("Usuário sem permissão de exclusão.");
      return;
    }
    
    this.spinner.show("integrationsLoading");
    this.dialogServices.title = "Exclusão de Integração";

    this.dialogServices.openNewDialog(
      "Deseja excluir a integração?",
      () => {
        try{
          this.IntegrationServices.removeIntegration(this.idConf, sequence).then(
            (x) => {
              this.loadIntegrations(); //Entender se vamos recarregar as integrações quando alguem for deletado
              this.spinner.hide("integrationsLoading");
            }
          ).catch(reason=>{
            this.spinner.hide("integrationsLoading");
          });
        }catch(e){
          this.spinner.hide("integrationsLoading");
          throw e;
        }
         
      },
      () => {
        this.spinner.hide("integrationsLoading");
      }
    );
  }

  selectIntegration(intSelectedItem) {
    this.intSelectedItem = intSelectedItem;
  }

  drop(event: CdkDragDrop<{ title: string; poster: string }[]>) {

    if ( !this.canInsert){
      this.snackBar.showError("Usuário sem permissão de inserção.");
      return;
    }
    //moveItemInArray(this.movies, event.previousIndex, event.currentIndex);
    if (event.previousContainer === event.container) {
      // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      let typeIntegration = this.intData[event.previousIndex];
      this.saveIntegration(this.idConf, typeIntegration);
    }
  }
}
